/*eslint-disable*/

const asyncValidate = (values, dispatch, props) => {
  let blurredField = props.lastBlurredState;

  if (blurredField === 'submit') {
    return props.makePayment(props.basketId, values, props.totalToPay).then(res => {
      if (res.hasFailed) {
        throw { _error: res.data };
      }
    }); 
    
  }
  let apiResponse = { [blurredField]: values[props.lastBlurredState] };

  return props.validatePayment(props.basketId, apiResponse).then(result => {
    // console.log(props.basketId, apiResponse, result);
    if (result.hasFailed) {
      const myArr = result.data.reduce((obj, item) => {
        let name = item.validation_field;
        obj[name] = item.message;
        return obj;
      }, {});
      throw myArr;
    }
  });
};

export default asyncValidate;



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/asyncValidate.js